// 搜尋遊戲 API 可接受的條件，不含排序條件
export const legalQueryList = ['q', 'city', 'ft', 'pp', 'price', 'languages', 'storeId', 'outdoor', 'outdoor_only', 'big', 'over', 'over_only', 'prmo', 'prnew', 'page', 'rand'];
// 上述再加上 sort
export const legalFullQueryList = [...legalQueryList, 'orderby'];